import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from "classnames";
import React from "react";
import { Translate, withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from "../../../store/storeFunctions";

class AmlPersonDetail extends React.Component {
    state = { open: false }

    render() {
        const hasBirthDateOnInputOnly = this.hasBirthDateOnInputOnly(this.props.candidate.dateOfBirthsFormatted);
        if (this.props.candidate.isCountryMatch && !this.props.candidate.sources.includes(this.props.candidate.primaryName))
            this.props.candidate.sources.push(this.props.candidate.primaryName);

        return (
            <React.Fragment>
                <tr className={classnames({ "highlighted": this.state.open })} onClick={() => this.setState({ open: !this.state.open })} style={{ cursor: "pointer", fontWeight: this.state.open ? "600" : "400" }}>
                    <td><FontAwesomeIcon style={{ flexBasis: '5%' }} icon="user-tie" className='svg-standard-color'></FontAwesomeIcon></td>
                    <td>{this.props.candidate.isCountryMatch ? isNullOrUndefined(this.props.candidate.country) ? isNullOrUndefined(this.props.candidate.furtherCountries[0]) ? "" : this.props.candidate.furtherCountries[0] : this.props.candidate.country : this.props.candidate.primaryName}</td>

                    <td className={classnames({ 'aml-candidate-red': hasBirthDateOnInputOnly })}>({this.props.candidate.confidenceRate} %)</td>

                    <td className={classnames({ 'aml-candidate-red': hasBirthDateOnInputOnly })}>
                        {hasBirthDateOnInputOnly ?
                            (!this.props.candidate.isCountryMatch ? this.props.translate("Report.Aml.Subjects.Unlisted") : "") :
                            this.props.candidate.dateOfBirthsFormatted.map((db, i) => {
                                return (
                                    <span key={i} style={{ marginLeft: i === 0 ? "" : "0.5em" }}>{db}</span>
                                )
                            })}
                    </td>
                    <td>
                        {this.props.candidate.placesOfBirth.map((pb, i) => {
                            return (<span key={i} style={{ marginLeft: i === 0 ? "" : "0.5em" }}>{pb}</span>)
                        })}
                    </td>
                    <td>
                        <span>{this.props.candidate.sources.join(", ")}</span>)
                        <span className="icon" style={{ alignSelf: "center" }}>
                            <FontAwesomeIcon icon="angle-down" className='svg-standard-color' />
                        </span>
                    </td>
                </tr>
                {this.state.open &&
                    <tr style={{ borderBottom: "2px solid" }}>
                        <td colSpan="6">
                            <table className="table table-report-section-2" style={{ fontSize: "1em" }}>
                                <tbody>
                                    {this.renderRow("Report.Aml.Subjects.FurtherNames", this.props.candidate.furtherNames)}
                                    {this.renderRow("Report.Aml.Subjects.KnownAddresses", this.props.candidate.knownAddresses)}
                                    {this.renderRow("Report.Aml.Subjects.PassportOrIds", this.props.candidate.passportsOrIds)}
                                    {this.renderRow("Report.Aml.Subjects.Age", this.props.candidate.age, false)}
                                    {this.renderRow("Report.Aml.Subjects.FurtherCountries", this.props.candidate.furtherCountries)}
                                    {this.renderRow("Report.Aml.Subjects.Domicil", this.props.candidate.country, false)}
                                    {this.renderRow("Report.Aml.Subjects.Keywords", this.props.candidate.keywords)}
                                    {this.renderRow("Report.Aml.Subjects.AdditionalInfo", this.props.candidate.additionalInfo)}
                                    {this.renderRow("Report.Aml.Subjects.Titles", this.props.candidate.titles)}
                                    {this.renderRow("Report.Aml.Subjects.DateOfLastUpdate", this.props.candidate.datesOfLastUpdateFormatted, true, true)}
                                    {this.renderRow("Report.Aml.Subjects.Publisher", this.props.candidate.publishers)}
                                </tbody>
                            </table>

                        </td>
                    </tr>
                }

            </React.Fragment>
        )
    }

    hasBirthDateOnInputOnly = (dateOfBirths) => this.props.hasBirthDate && (isNullOrUndefined(dateOfBirths) || dateOfBirths.length === 0);

    renderRow(label, field, isArray = true, isDate = false) {
        if (isArray && (isNullOrUndefined(field) || field.length == 0)) return "";
        if (!isArray && isNullOrUndefined(field)) return "";
        return (
            <React.Fragment>
                <tr>
                    <td><Translate id={label} /> </td>
                    {isDate && isArray &&
                        <td>
                            {field.map((f, i) => {
                                return (<span key={i}>{(i === (field.length - 1)) ? f : `${f}; `}</span>)
                            })}
                        </td>
                    }
                    {!isDate && <td>{isArray ? field.join(",") : field}</td>}
                </tr>
            </React.Fragment>
        )
    }
}

export default withLocalize(AmlPersonDetail);